const fateChart = [
    {
        odd: "certain",
        by_chaos: [[10, 50, 91], [13, 65, 94], [15,75, 96], [17, 85, 98], [18, 90, 99], [19, 95, 100], [20, 99, 100], [20, 99, 100], [20, 99, 100]]
    },
    {
        odd: "nearly certain",
        by_chaos: [[7, 35, 88], [10, 50, 91], [13, 65, 94], [15, 75, 96], [17, 85, 98], [18, 90, 99], [19, 95, 100], [20, 99, 100], [20, 99, 100]]
    },
    {
        odd: "very likely",
        by_chaos: [[5, 25, 86], [7, 35, 88], [10, 50, 91], [13, 65, 94], [15, 75, 96], [17, 85, 98], [18, 90, 99], [19, 95, 100], [20, 99, 100]]
    },
    {
        odd: "likely",
        by_chaos: [[3, 15, 84], [5, 25, 86], [7, 35, 88], [10, 50, 91], [13, 65, 94], [15, 75, 96], [17, 85, 98], [18, 90, 99], [19, 95, 100]]
    },
    {
        odd: "50/50",
        by_chaos: [[2, 10, 83], [3, 15, 84], [5, 25, 86], [7, 35, 88], [10, 50, 91], [13, 65, 94], [15, 75, 96], [17, 85, 98], [18, 90, 99]]
    },
    {
        odd: "unlikely",
        by_chaos: [[1, 5, 82], [2, 10, 83], [3, 15, 84], [5, 25, 86], [7, 35, 88], [10, 50, 91], [13, 65, 94], [15,75,96], [17, 85, 98]]
    },
    {
        odd: "very unlikely",
        by_chaos: [[1, 1, 81], [1, 5, 82], [2, 10, 83], [3, 15, 84], [5, 25, 86], [7, 35, 88], [10, 50, 91], [13, 65, 94], [15,75,96]]
    },
    {
        odd: "nearly impossible",
        by_chaos: [[1, 1, 81], [1, 1, 81], [1, 5, 82], [2, 10, 83], [3, 15, 84], [5, 25, 86], [7, 35, 88], [10, 50, 91], [13, 65, 94]]
    },
    {
        odd: "impossible",
        by_chaos: [[1, 1, 81], [1, 1, 81], [1, 1, 81], [1, 5, 82], [2, 10, 83], [3, 15, 84], [5, 25, 86], [7, 35, 88], [10, 50, 91]]
    }
]

export default fateChart
